export default __webpack_public_path__ + "static/media/full.4f80926a.png";